// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.change-compare-table[data-v-8356aee6] {\n  border-radius: 8px;\n}\n.empty-wrap[data-v-8356aee6] {\n  padding: 12px 0 2px;\n  color: #909399;\n  font-size: 13px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
